<button class="headerbar-action" (click)="this.toggleMenu()">
  <div class="headerbar-action-icon">menu</div>
</button>
